import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { finalize } from 'rxjs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { environment } from '../../../environments/environment';
import { APP_ROUTES } from '../constants/app-routes';
import { AuthenticationService } from '../services/authentification.service';
import { FlashService } from '../services/flash.service';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.css'],
    imports: [
        CommonModule,
        RouterLink,
        RouterLinkActive,
        FontAwesomeModule,
        TranslateModule,
    ]
})
export class NavComponent {
  menuOpen = false;
  readonly appVersion = environment.appVersion;
  readonly currentYear = new Date().getFullYear();
  readonly routes = APP_ROUTES;
  readonly flashMessage$;

  constructor(
    private readonly authService: AuthenticationService,
    private readonly flashService: FlashService
  ) {
    this.flashMessage$ = this.flashService.message$;
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(): void {
    this.menuOpen = false;
  }

  dismissFlash(): void {
    this.flashService.clear();
  }

  openLauncher(): void {
    this.authService.openLauncher();
  }

  logout(): void {
    this.authService
      .logout()
      .pipe(
        finalize(() =>
          // Revenir sur EasyLoc après reconnexion (sinon le launcher ouvre /accueil).
          this.authService.redirectToLauncherLogin(window.location.origin + '/')
        )
      )
      .subscribe();
  }
}
